import { frApp, frWebsite } from './strings';

const fr = {
  translation: {
    ...frApp,
    ...frWebsite
  }
};

export default fr;
